import React from 'react'
import { Container, BtnPlay, ScrollHWrapper } from 'components/base-ui'
import { MediaTypeEnum, getResizableURL, getTypeImageFromExtension } from 'helpers/image'
import { ScheduledContentType } from 'types'
import { ListScheduledContentsQuery as ListScheduledContentsQueryDineIn } from 'graphQL/dinein/generate/operations'
import { FeatureCards, SlideWrapperFeatures, FeatureCard, BtnPlayWrapper } from 'components/vendor-detail'

export const SCHEDULESCONTENT_TYPE = {
  SINGLEMEDIA: 'SingleMedia',
  SINGLEPRODUCT: 'SingleProduct',
  CATEGORY: 'Category',
}

interface ScheduledContentSliderProps {
  listScheduleContent: any[]
  onClickProduct?: (product: any) => void
  getElementNameMenuCategoryById?: (id: number | string) => string
  getIndexMenuCategoryById?: (id: number | string) => number
  handleClickTargetMenu?: (index: number) => void
  scrollToElement?: (elementName: string) => void
  onClickBanner?: (
    scheduleContent: ScheduledContentType | ListScheduledContentsQueryDineIn['listScheduledContents'][number],
    index?: number
  ) => void
  fancyBoxGalleryName?: string
}

const ScheduledContentSlider: React.FC<ScheduledContentSliderProps> = ({
  listScheduleContent,
  onClickProduct,
  getElementNameMenuCategoryById,
  getIndexMenuCategoryById,
  handleClickTargetMenu,
  scrollToElement,
  onClickBanner,
  fancyBoxGalleryName = 'gallery',
}) => {
  return (
    <Container>
      <FeatureCards>
        <SlideWrapperFeatures>
          <ScrollHWrapper style={{ paddingTop: '8px' }}>
            {listScheduleContent.map((scheduleContent, i) => {
              const isSingleProduct = scheduleContent.type === SCHEDULESCONTENT_TYPE.SINGLEPRODUCT ? true : false
              const isCategory = scheduleContent.type === SCHEDULESCONTENT_TYPE.CATEGORY ? true : false

              const thumbnailImage = scheduleContent.images.find((image) => image.type === 'Horizontal')

              const haveImage = thumbnailImage ? true : false
              let coverPath = ''
              let _imagePath = ''
              let type = ''
              let isVideoType = false
              let _videoPath = ''

              if (haveImage) {
                const { originalURL, resizableURL } = thumbnailImage
                type = getTypeImageFromExtension(originalURL)
                isVideoType = type === MediaTypeEnum.VIDEO ? true : false
                if (isVideoType) {
                  const coverImage = scheduleContent.images.find((image) => image.type === 'HorizontalThumbnail')

                  if (coverImage) {
                    coverPath = getResizableURL([{ resizableURL: coverImage.resizableURL }], {
                      width: '735',
                      height: '420_fmt-jpg',
                    })
                    // coverPath = coverImage.resizableURL.replace('{width}', '735').replace('{height}', '420_fmt-jpg')
                  }
                  _videoPath = originalURL
                } else {
                  _imagePath = originalURL
                  coverPath = getResizableURL([{ resizableURL }], { width: '735', height: '420_fmt-jpg' })
                  // coverPath = resizableURL.replace('{width}', '735').replace('{height}', '420_fmt-jpg')
                }
              }

              const dataFancyBox =
                !isSingleProduct && !isCategory
                  ? { 'data-fancybox': fancyBoxGalleryName, href: `${isVideoType ? _videoPath : _imagePath}` }
                  : {}

              return (
                <FeatureCard
                  key={i}
                  {...dataFancyBox}
                  video={isVideoType}
                  style={{
                    backgroundImage: `url('${coverPath}')`,
                  }}
                  data-type={isVideoType ? 'video' : 'image'}
                  onClick={(e) => {
                    if (onClickBanner) {
                      onClickBanner(scheduleContent, i)
                      return
                    }
                    if (isSingleProduct && onClickProduct) {
                      onClickProduct(scheduleContent.products[0])
                    }

                    if (
                      isCategory &&
                      getElementNameMenuCategoryById &&
                      getIndexMenuCategoryById &&
                      handleClickTargetMenu &&
                      scrollToElement
                    ) {
                      const elemntNameTarget = getElementNameMenuCategoryById(scheduleContent.categoryID)
                      if (elemntNameTarget) {
                        const elementCateTargetIndex = getIndexMenuCategoryById(scheduleContent.categoryID)
                        handleClickTargetMenu(elementCateTargetIndex)
                        scrollToElement(elemntNameTarget)
                      }
                    }
                  }}
                >
                  {isVideoType && (
                    <BtnPlayWrapper>
                      <BtnPlay />
                    </BtnPlayWrapper>
                  )}
                </FeatureCard>
              )
            })}
          </ScrollHWrapper>
        </SlideWrapperFeatures>
      </FeatureCards>
    </Container>
  )
}

export default ScheduledContentSlider
